// extracted by mini-css-extract-plugin
export default {"root":"sideNavigationMenu_root__88iDx","title":"sideNavigationMenu_title__PHvmb","container":"sideNavigationMenu_container__Tiv-M","divider":"sideNavigationMenu_divider__EUqpn"};